import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from 'theme-ui'
import Link from 'gatsby-link'

import media from './../../../common/MediaQueries'
import { transition } from './../../../common/Mixins'
import { WithTheme } from './../../../setup/index'
import { PostBoxStylesProps } from './types'

const PostBoxMediaStyled = styled.div<WithTheme<PostBoxStylesProps>>`
  display: flex;
  height: 12.5rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 1.375rem;
  border-radius: 0.3125rem;
  overflow: hidden;

  .lazy-load-image-background {
    width: 100%;
  }

  .lazy-load-image-background.blur.lazy-load-image-loaded {
    ${transition}
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media ${media.maxPhone} {
    max-width: 23rem;
  }

  ${({ isPrimary }) =>
    isPrimary &&
    css`
      height: 13.4375rem;
    `};

  ${({ withoutMedia }) =>
    withoutMedia &&
    css`
      display: none;
    `};
`

const PostBoxContainerStyled = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  @media ${media.phone} {
    padding: 0 0.375rem;
  }
`

const PostBoxDateStyled = styled(Text)<WithTheme>`
  font-size: 0.6875rem;
  color: ${({ theme }) => theme.colors.gray4};
  margin-bottom: 0.5rem;
  @media ${media.phone} {
    font-size: 0.875rem;
    margin-bottom: 0.75rem;
  }
`

const PostBoxCategoryStyled = styled(Text)<WithTheme>`
  color: ${({ theme }) => theme.colors.green};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: 0.9375rem;
  font-family: ${({ theme }) => theme.fonts.secondary};
  margin-bottom: 0.5rem;
  @media ${media.phone} {
    font-size: 1.25rem;
  }
`

const PostBoxTitleStyled = styled.p<WithTheme>`
  font-size: 1.125rem;
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: 0.625rem;
  @media ${media.phone} {
    font-size: 1.4375rem;
    line-height: 1.4;
    margin-bottom: 1.5rem;
    max-width: 20rem;
  }
`

const PostBoxContentStyled = styled(Text)`
  font-size: 0.875rem;
  line-height: 1.7;
`

const PostBoxStyled = styled(Link)`
  width: 100%;
  &:hover {
    @media ${media.tablet} {
      ${PostBoxMediaStyled} {
        .lazy-load-image-background.blur.lazy-load-image-loaded {
          transform: scale(1.2);
        }
      }
    }
  }
`

export {
  PostBoxStyled,
  PostBoxMediaStyled,
  PostBoxDateStyled,
  PostBoxCategoryStyled,
  PostBoxTitleStyled,
  PostBoxContentStyled,
  PostBoxContainerStyled
}
